import React from 'react';
import styled from 'styled-components';

import { ProgressMeter } from './ProgressMeter';
import { ProgressAccuracy } from './ProgressAccuracy';
import { calculateAverageSessionScore } from './calculateAverageSessionScore';

const ProgressWrapper = styled.div`
   position: relative;

   p {
      font-family: var(--heading-font);
      font-size: 1rem;
   }

   .progress-accuracy {
      text-align: center;
      position: absolute;
      bottom: 1em;
      left: 0;
      right: 0;
      font-size: 0.9em;

      span {
         display: block;
         margin-bottom: 0.25em;
      }
   }

   .progress-indicator {
      width: 100%;
   }
   .progress-text {
      position: absolute;
      inset: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
   }
   .progress-label {
      display: block;
      margin-bottom: 0.5em;
      margin-top: -1em;
   }
   .progress-numerator {
      font-size: 2.5em;
      min-width: 1.5em;
      display: inline-block;
      text-align: right;
   }
   .progress-denominator {
      font-size: 0.75em;
      vertical-align: sub;
   }
   .progress-level-from-aux {
      text-align: center;
   }

   .progress-accuracy {
      svg {
         vertical-align: top;
         margin-right: 0.25em;
      }
   }
`;

const ExerciseProgress = ({
   hasProgress,
   exerciseInfo,
   exerciseProgress,
   calculateFromAux,
}) => {
   const modules = exerciseProgress.modules
      ? Object.values(exerciseProgress.modules)
      : null;

   let currentLevel = 0;
   if (hasProgress || exerciseProgress.currentLevel > 1) {
      currentLevel = exerciseProgress.currentLevel;
   } else if (exerciseProgress.tutorialComplete) {
      currentLevel = 1;
   }

   return (
      <ProgressWrapper className="progress-wrapper">
         <ProgressMeter
            progress={
               (hasProgress || exerciseProgress.currentLevel > 1
                  ? exerciseProgress.currentLevel
                  : 0) / exerciseInfo.levelCount
            }
         />
         <div className="progress-text">
            <p>
               <span className="progress-label">Level</span>
               {calculateFromAux ? (
                  <span>
                     <span className="progress-numerator progress-level-from-aux">
                        {exerciseProgress.currentLevel +
                           modules.reduce(
                              (sum, { currentLevel }) => sum + currentLevel,
                              0
                           )}
                     </span>
                  </span>
               ) : (
                  <span>
                     <span className="progress-numerator">{currentLevel}</span>
                     <span className="progress-denominator">
                        /{exerciseInfo.levelCount}
                     </span>
                  </span>
               )}
            </p>
         </div>
         {hasProgress && (
            <ProgressAccuracy
               accuracy={Math.round(
                  calculateFromAux
                     ? // I can't believe I have done this, where are my standards!
                       calculateAverageSessionScore(
                          modules.flatMap(({ accuracy }) => ({
                             score: accuracy,
                          }))
                       )
                     : exerciseProgress.accuracy
               )}
            />
         )}
      </ProgressWrapper>
   );
};

export { ExerciseProgress };
